module.exports = __webpack_public_path__ + "static/media/map.02ec6f09.jpg";